import React from 'react';
import './Completed.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

interface CompletedProps {
  count: number;
  isActive?: boolean;
}

const Completed: React.FC<CompletedProps> = ({ count, isActive = false }) => {
  return (
    <div
      className={`table-task-completed-container ${isActive ? 'active' : ''}`}
    >
      <span className="data-bar-icon completed">
        <FontAwesomeIcon icon={faCircleCheck} />
      </span>
      <span className="table-task-completed-label">Completed</span>
      <span className="table-task-completed-count">{count}</span>
    </div>
  );
};

export default Completed;
